import { makeVar } from '@apollo/client'
import type { IntlShape } from 'react-intl'

import { buildReminderInitialValues, getCaseSelectedMortgage } from './TaskManagement/CaseVerifications.helpers'

export const caseOverviewLoadingStatus = makeVar<boolean>(false)

export const getRecommendedProtectionProducts = (details: Case) => {
  return (
    details.protection_products?.filter((protection_product) => protection_product?.details?.status === 'SELECTED') ||
    []
  )
}

export const setInitialReminderValues = (
  details: Case,
  user: User,
  intl: IntlShape,
  lenderName: string,
  earliestGIProductEndDate?: Date,
  selectedMortgage?: Mortgage | null,
) => {
  if (details) {
    const mortgage = selectedMortgage ?? getCaseSelectedMortgage(details as Case)
    return buildReminderInitialValues(
      user!,
      intl,
      lenderName,
      mortgage,
      details.preference_mortgage_reason,
      earliestGIProductEndDate,
    )
  }
  return {}
}

export enum TasksLocation {
  CaseOverview = 'CASE_OVERVIEW',
  CaseSidebarDrawer = 'CASE_SIDEBAR_DRAWER',
}
